<script>
import { required } from 'vuelidate/lib/validators';
import Properties from "@/components/widgets/property-list.vue";
import Clients from "@/components/widgets/client-list.vue";
import Employees from "@/components/widgets/employee-list.vue";
import DatePicker from "vue2-datepicker";

export default {
    name: "SubsidiaryLedgerModal",
    components: {
        Properties,
        Clients,
        Employees,
        DatePicker
    },
    props: {
        modalTitle: {
            type: String,
            default: "Subsidiary Ledger",
        },
        slTypes: {
            type: Array,
            default: () => [],
        },
    },
    validations: {
        form: {
            code: { required },
            accountNumber: { required },
            subsidiaryLedgerTypeId: { required },
            referenceId: { required },
            title: { required }
        }
    },
    data() {
        return {
            form: {
                id: 0,
                referenceId: null,
                referenceType: 'client',
                code: null,
                title: null,
                description: null,
                subsidiaryLedgerTypeId: null,
                contractNumber: null,
                osContinuing: false,
                validFromDate: null,
                validToDate: null,
                createdByUser: null,
                isActive: false,
                accountNumber: "",
                client: "",
                projectName: "",
                contractNo: "",
            },
            submitted: false,
            isSubmitting: false,
            selectedRefTitle: '',
            selectedReference: null,
        };
    },
    computed: {
        slTypeOptions() {
            return this.slTypes.map(type => ({
                value: type.id,
                text: type.type
            }));
        },
        isEditMode() {
            return this.form.id > 0;
        },
    },
    methods: {
        resetForm() {
            this.form = {
                id: 0,
                referenceId: null,
                referenceType: 'client',
                code: null,
                title: null,
                description: null,
                subsidiaryLedgerTypeId: null,
                contractNumber: null,
                osContinuing: false,
                validFromDate: null,
                validToDate: null,
                createdByUser: null,
                isActive: false,
                // Additional fields from template
                accountNumber: "",
                client: "",
                projectName: "",
                contractNo: "",
            };
            this.submitted = false;
            this.isSubmitting = false;
            this.$v.$reset();
        },
        updateData(data) {
            this.form = data
            this.form.validFromDate = new Date(data.validFromDate);
            this.form.validToDate = new Date(data.validToDate);
            this.submitted = false;
            this.isSubmitting = false;
        },
        async submitForm() {
            this.submitted = true;
            this.$v.form.$touch();
            
            if (this.$v.form.$invalid) {
                return;
            }
            this.isSubmitting = true;
            let data = JSON.parse(JSON.stringify(this.form));
            data.validFromDate = this.getDate(this.form.validFromDate);
            data.validToDate = this.getDate(this.form.validToDate);
            this.$emit("submit", data);
        },
        getProperty(data) {
            this.selectedReference = data;
            this.form.referenceId = data.id;
            this.$bvModal.hide('client-property-emp');
        },
        getClient(data) {
            this.selectedReference = data;
            this.form.referenceId = data.id;
            this.$bvModal.hide('client-property-emp');
        },
        getEmployee(data) {
            this.selectedReference = data;
            this.form.referenceId = data.id;
            this.$bvModal.hide('client-property-emp');
        },
        getClients(){
            if(this.form.referenceType == 'client'){
                this.selectedRefTitle = 'Select Client';
            } else if(this.form.referenceType == 'employee'){
                this.selectedRefTitle = 'Select Employee';
            } else if(this.form.referenceType == 'property'){
                this.selectedRefTitle = 'Select Property';
            }
            this.$bvModal.show('client-property-emp');
        },
        showReferenceModal(type){
            this.form.referenceType = type;
            if(type === 'client'){
                this.selectedRefTitle = 'Select Client';
            } else if(type === 'employee'){
                this.selectedRefTitle = 'Select Employee';
            } else if(type === 'property'){
                this.selectedRefTitle = 'Select Property';
            }
            this.$bvModal.show('client-property-emp');
        },
        removeClient(){
            this.selectedReference = null;
            this.form.referenceId = 0;
        },
    },
};
</script>

<template>
    <b-modal
        id="subsidiary-ledger-modal"
        :title="modalTitle"
        size="lg"
        hide-footer
    >
        <form 
            @submit.prevent="submitForm"
            class="needs-validation"
        >
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="code">Code</label>
                    <b-form-input
                        id="code"
                        v-model="form.code"
                        type="text"
                        placeholder="Enter code"
                        autocomplete="off"
                        :class="{
                            'is-invalid': submitted && $v.form.code.$error,
                        }"
                    ></b-form-input>
                    <div
                        v-if="submitted && $v.form.code.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.code.required">This value is required.</span>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="contractNumber">Contract Number</label>
                    <b-form-input
                        id="contractNumber"
                        v-model="form.contractNumber"
                        type="text"
                        placeholder="Enter contract number"
                        autocomplete="off"
                    ></b-form-input>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="accountNumber" >
                        Account Number 
                    </label>
                    <b-form-input
                        id="accountNumber"
                        v-model="form.accountNumber"
                        type="text"
                        placeholder="Enter account number"
                        autocomplete="off"
                        :class="{
                            'is-invalid': submitted && $v.form.accountNumber.$error,
                        }"
                    ></b-form-input>
                    <div
                        v-if="submitted && $v.form.accountNumber.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.accountNumber.required">This value is required.</span>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="subsidiaryLedgerTypeId" >
                        SL Type 
                    </label>
                    <b-form-select
                        id="subsidiaryLedgerTypeId"
                        class="form-select"
                        v-model="form.subsidiaryLedgerTypeId"
                        :options="slTypeOptions"
                        autocomplete="off"
                        :class="{
                            'is-invalid': submitted && $v.form.subsidiaryLedgerTypeId.$error,
                        }"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                -- Select SL Type --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                    <div
                        v-if="submitted && $v.form.subsidiaryLedgerTypeId.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.subsidiaryLedgerTypeId.required">This value is required.</span>
                    </div>
                </div>
                
                <div class="col-md-12 mb-3">
                    <label for="title" >
                        Title/Project Name 
                    </label>
                    <b-form-input
                        id="title"
                        v-model="form.title"
                        type="text"
                        placeholder="Enter project name"
                        autocomplete="off"
                        :class="{
                            'is-invalid': submitted && $v.form.title.$error,
                        }"
                    ></b-form-input>
                    <div
                        v-if="submitted && $v.form.title.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.title.required">This value is required.</span>
                    </div>
                </div>

                <!-- Client -->
                <div class="col-md-12 mb-3">
                    <div class="d-flex align-items-center gap-1">
                        <label 
                            for="client" 
                            class="px-2 cursor-pointer rounded" 
                            :class="{'bg-purple text-white' : form.referenceType === 'client', 'border border-2' : form.referenceType !== 'client'}"
                            @click="showReferenceModal('client')"
                        >
                            Client 
                        </label>
                        <label 
                            for="emp" 
                            class="px-2 cursor-pointer border rounded border-2" 
                            :class="{'bg-purple text-white rounded' : form.referenceType === 'employee'}"
                            @click="showReferenceModal('employee')"
                        >
                            Employee
                        </label>
                        <label 
                            for="property" 
                            class="px-2 cursor-pointer border rounded border-2" 
                            :class="{'bg-purple text-white rounded' : form.referenceType === 'property'}"
                            @click="showReferenceModal('property')"
                        >
                            Property
                        </label>
                    </div>
                    <b-input-group>
                        <template #append>
                            <b-button @click="getClients" variant="outline-info" :title="`Search ${form.referenceType.toUpperCase()}`">
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                            <b-button @click="removeClient" variant="outline-danger" v-if="form.referenceId" :title="`Remove ${form.referenceType.toUpperCase()}`">
                                <i class="bx bx-x"></i>
                            </b-button>
                        </template>
                        <div 
                            class="form-control" 
                            v-if="form.referenceType === 'client'"
                            :class="{ 'is-invalid': submitted && $v.form.referenceId.$error }"
                        >
                            {{ selectedReference ? selectedReference.name : 'No Client Selected' }}
                        </div>
                        <div 
                            class="form-control" 
                            v-if="form.referenceType === 'employee'"
                            :class="{ 'is-invalid': submitted && $v.form.referenceId.$error }"
                        >
                            {{ selectedReference ? selectedReference.name : 'No Employee Selected' }}
                        </div>
                        <div 
                            class="form-control" 
                            v-if="form.referenceType === 'property'"
                            :class="{ 'is-invalid': submitted && $v.form.referenceId.$error }"
                        >
                            {{ selectedReference ? selectedReference.name : 'No Property Selected' }}
                        </div>
                    </b-input-group>
                    <div
                        v-if="submitted && $v.form.referenceId.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.referenceId.required">This value is required.</span>
                    </div>
                </div>

                <!-- Validity Date -->
                <div class="col-md-12 mb-3">
                    <label for="validityDate" >Validity Date (From ~ To)</label>
                    <div class="d-flex gap-1 align-items-center">
                        <date-picker
                            v-model="form.validFromDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Schedule..."
                            type="date"
                        ></date-picker>
                        <span>~</span>
                        <date-picker
                            v-model="form.validToDate"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Schedule..."
                            type="date"
                        ></date-picker>

                    </div>
                </div>

                <!-- Description -->
                <div class="col-md-12 mb-3">
                    <label for="description" >Description</label>
                    <b-form-textarea
                        id="description"
                        v-model="form.description"
                        placeholder="Enter description (optional)"
                        rows="3"
                        autocomplete="off"
                    ></b-form-textarea>
                </div>

                <!-- Is Continuing (osContinuing) -->
                <div class="col-md-6 mb-3">
                    <div class="form-check">
                        <input
                            id="osContinuing"
                            v-model="form.osContinuing"
                            type="checkbox"
                            class="form-check-input"
                            autocomplete="off"
                        />
                        <label class="form-check-label" for="osContinuing">
                            Is Continuing?
                        </label>
                    </div>
                </div>

                <!-- Is Active -->
                <div class="col-md-6 mb-3">
                    <div class="form-check">
                        <input
                            id="isActive"
                            v-model="form.isActive"
                            type="checkbox"
                            class="form-check-input"
                            autocomplete="off"
                        />
                        <label class="form-check-label" for="isActive">
                            Active
                        </label>
                    </div>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="d-flex justify-content-end gap-2 pt-3 border-top">
                <b-button
                    variant="secondary"
                    @click="$bvModal.hide('subsidiary-ledger-modal')"
                    :disabled="isSubmitting"
                >
                    Cancel
                </b-button>
                <b-button
                    type="submit"
                    variant="primary"
                    :disabled="isSubmitting"
                >
                    <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ isEditMode ? 'Update' : 'Create' }} Subsidiary Ledger
                </b-button>
            </div>
        </form>
        <b-modal
            id="client-property-emp"
            :title="selectedRefTitle"
            size="lg"
            hide-footer
        >
            <Properties @fetchprop="getProperty" v-if="form.referenceType === 'property'" />
            <Clients @fetchclient="getClient" v-if="form.referenceType === 'client'" />
            <Employees @fetchemployee="getEmployee" v-if="form.referenceType === 'employee'" />
        </b-modal>
    </b-modal>
</template>